<template>
	<div class="orders-container">
		<div class="orders-list-container">
			<div class="macro-filters-container">
				<div class="first-row">
					<AppTabsSwitch :items="[getString('in_progress'), getString('completed')]" @switched="switchedCompleted" :active-item="ordersStore.showCompleted ? 1 : 0" auto-switch />
					<div class="right-filters">
						<div v-show="userStore?.currSubscription !== 'free'" class="order-switch order-switch-filter" :class="{selected: filtersActive, searching: isFiltering}" @click="filtersActive = true">
							<img :src="'https://img.qromo.io/img/icons/icon-filters-primary'+(userStore.darkMode ? '-dark' : '')+'.svg'" alt="">
						</div>
						<div class="search-container">
							<AppClickableIcon class="search-icon" icon-name="iconX" @click="cancelSearch"
											  v-if="!ordersStore.searchLoading && !!ordersStore.search"/>
							<AppLoader class="search-loader" :size="20" v-if="ordersStore.searchLoading"/>
							<AppTextInput v-if="expandedSearch" :class="{searching: ordersStore.search ? ordersStore.search.length > 0 : false}" ref="search-input" icon-name="icon-magnify" :value="ordersStore.search" :placeholder="getString('search')"
										  @changed-text="searchOrders"/>
							<div v-else class="order-switch order-switch-search" :class="{selected: showSearch, searching: ordersStore.search ? ordersStore.search.length > 0 : false}" @click="toggleSearch">
								<img :src="'https://img.qromo.io/img/icons/icon-search-primary' + (this.userStore.darkMode ? '-dark' : '') + '.svg'" alt="">
								<AppInPlaceCloud :active="showSearch">
									<AppTextInput v-click-out-side="closeSearch" ref="search-input-modal" :value="ordersStore.search" :placeholder="getString('search')" @changed-text="searchOrders" />
								</AppInPlaceCloud>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="orders-list">
				<div class="all-orders-container" :class="{appearing: !noOrders}">
					<div class="warning-old-qrs" v-if="ordersStore.isUsingOldQrs">
						<div class="warning-icon" v-html="svgStore.get('iconWarning')"></div>
						<div class="warning-info">
							<div class="warning-title">{{ getString('warning') }}</div>
							<div class="warning-body">{{ getString('warning_old_qrs') }}</div>
						</div>
					</div>
					<div class="orders-list-wrapper" v-if="ordersStore.loaded && ordersStore.orderGroups.length > 0">
						<OrderRow
							v-for="orderGroup in ordersStore.orderGroups"
							:key="orderGroup.groupIdentifier"
							:orders-group="orderGroup"
							@click="clickOrderRow(orderGroup)"/>
					</div>
				</div>
				<div class="no-orders-container" v-if="noOrdersDelayed" :class="{appearing: noOrders}">
					<div class="no-orders" v-if="ordersStore.loaded">
						<div class="no-orders-text">{{ getString('no_orders') }}</div>
					</div>
					<div class="no-orders" v-if="!ordersStore.loaded">
						<AppLoader />
					</div>
				</div>
			</div>
			<PaginationRow :page="ordersStore.page" :page-size="ordersStore.pageSize" :total="ordersStore.totalOrderCards" :initial-page-size="ordersStore?.pageSize || 25"
						   @page-changed="pageChanged"/>
		</div>
		<div class="order-details-container"
			 :class="{transition: ordersStore.transitioningMobileOrderSummary, active: ordersStore.showMobileOrderSummary}"
			 @click.self="ordersStore.deactivateMobileOrderSummary()">
			<OrderSummary />
		</div>
		<BottomPayment is-orders :no-pay-later="counterStore.noPayLater" :customer-not-editable="counterStore.customerNotEditable" :items-split="itemsSplit"
					   :active="paymentActive" @toggling-popup="togglingPayment" @payment-done="paymentDone" :total="groupTotal"
					   :paid-value="paidValue" :default-dutch-people="defaultDutchPeople" />
		<DeliveryInfoSheet />
		<SendReceiptSheet />
		<SendReceiptEpsonSheet />
		<AppBottomSheet :force-width="bottomSheetWidth" :active="filtersActive" @toggling-popup="togglingFilters">
			<div class="filters-active-container" v-if="filtersActive">
				<ModalHeader :title="getString('orders_filters')" />
				<AppList :items="filters">
					<template #order-mode-filters="{item}">
						<div class="list-item-header">
							<p class="list-item-title">{{ item.title }}</p>
							<div class="filters-order-mode">
								<OrderModeFilter v-if="userStore.currBusinessId && userStore.currPlans.counter"
												 :icon="'https://img.qromo.io/img/icons/icon-direct-sale-primary' + (userStore.darkMode ? '-dark' : '') + '.svg'"
												 :value="0" :active="ordersStore.filterCounter"
												 @toggle="clickOnFilter('filterCounter')"/>
								<OrderModeFilter v-if="userStore?.currSubscription !== 'free'"
									:icon="'https://img.qromo.io/img/icons/icon-counter-table-primary' + (userStore.darkMode ? '-dark' : '') + '.svg'"
									:value="0" :active="ordersStore.filterRooms" @toggle="clickOnFilter('filterRooms')"/>
								<OrderModeFilter
									v-if="userStore.currBusinessId && userStore.currBusiness.plan_plugin_delivery"
									:icon="'https://img.qromo.io/img/icons/icon-counter-delivery-primary' + (userStore.darkMode ? '-dark' : '') + '.svg'"
									:value="0" :active="ordersStore.filterDelivery" @toggle="clickOnFilter('filterDelivery')"/>
								<OrderModeFilter
									v-if="userStore.currBusinessId && userStore.currBusiness.plan_plugin_takeaway"
									:icon="'https://img.qromo.io/img/icons/icon-takeaway-'+(userStore.currBusiness && userStore.currBusiness.type === 'other' ? 'other' : 'generic')+'-primary'+(userStore.darkMode ? '-dark' : '')+'.svg'"
									:value="0" :active="ordersStore.filterTakeaway" @toggle="clickOnFilter('filterTakeaway')"/>
							</div>
						</div>
					</template>
					<template #fiscal-status-filters="{item}">
						<div class="list-item-header">
							<p class="list-item-title">{{ item.title }}</p>
							<div class="filters-fiscal-status">
								<FiscalStatusFilter
									color="grey"
									:active="ordersStore.fiscalFilter === 'unfiscalized'"
									@toggle="clickOnFiscalFilter('unfiscalized')"/>
								<FiscalStatusFilter
									color="red"
									:active="ordersStore.fiscalFilter === 'pending'"
									@toggle="clickOnFiscalFilter('pending')"/>
								<FiscalStatusFilter
									color="orange"
									:active="ordersStore.fiscalFilter === 'fiscalized'"
									@toggle="clickOnFiscalFilter('fiscalized')"/>
							</div>
						</div>
					</template>
				</AppList>
			</div>
		</AppBottomSheet>
	</div>
</template>

<script>
import AppTabsSwitch from "@/shared/components/AppTabsSwitch.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import {useLanguageStore, useSvgStore, useNotificationStore} from "@/shared/stores";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import OrderModeFilter from "@/console-new/components/ops/orders/OrderModeFilter.vue";
import FiscalStatusFilter from "@/console-new/components/ops/orders/FiscalStatusFilter.vue";
import {useCounterStore, useMenuStore, useOrdersActionsStore, usePrintersStore, useRoomsStore, useUserStore} from "@/console-new/stores";
import OrderRow from "@/console-new/components/ops/orders/OrderRow.vue";
import OrderSummary from "@/console-new/components/ops/orders/OrderSummary.vue";
import {useOrdersStore} from "@/console-new/stores/orders.store";
import PaginationRow from "@/console-new/components/shared/PaginationRow.vue";
import AppLoader from "@/shared/components/AppLoader.vue";
import AppClickableIcon from "@/shared/components/AppClickableIcon.vue";
import BottomOrderEditor from "@/console-new/components/ops/counter/BottomOrderEditor.vue";
import BottomPayment from "@/console-new/components/ops/counter/BottomPayment.vue";
import DeliveryInfoSheet from "@/console-new/components/ops/orders/DeliveryInfoSheet.vue";
import SendReceiptSheet from "@/console-new/components/ops/orders/SendReceiptSheet.vue";
import AppInPlaceCloud from "@/shared/components/AppInPlaceCloud.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import clickOutSide from "@mahdikhashan/vue3-click-outside";
import SendReceiptEpsonSheet from "@/console-new/components/ops/orders/SendReceiptEpsonSheet.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppList from "@/shared/components/AppList.vue";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		const menuStore = useMenuStore();
		const ordersStore = useOrdersStore();
		const roomsStore = useRoomsStore();
		const printersStore = usePrintersStore();
		const svgStore = useSvgStore();
		const ordersActionsStore = useOrdersActionsStore();
		const counterStore = useCounterStore();
		const notificationStore = useNotificationStore();
		return {
			getString: languageStore.getString,
			userStore,
			menuStore,
			ordersStore,
			roomsStore,
			svgStore,
			printersStore,
			ordersActionsStore,
			counterStore,
			showNotification: notificationStore.showNotification,
		}
	},
	directives: {
		clickOutSide,
	},
	name: "OrdersContainer",
	mixins: [WindowWidth],
	components: {
		AppList,
		ModalHeader,
		AppInPlaceCloud,
		DeliveryInfoSheet,
		BottomPayment,
		BottomOrderEditor,
		SendReceiptSheet,
		SendReceiptEpsonSheet,
		AppLoader, OrderSummary, OrderRow, AppButtonIcon, AppTextInput, AppTabsSwitch, OrderModeFilter, FiscalStatusFilter, PaginationRow, AppClickableIcon, AppBottomSheet
	},
	data() {
		return {
			tablesOrders: 0,
			paymentActive: false,
			noOrdersDelayed: true,
			showSearch: false,
			filtersActive: false,
		}
	},
	computed: {
		filters() {
			let filtersList = [
				{
					title: this.getString('order_mode'),
					customSlot: 'order-mode-filters'
				}
			];

			// Only show fiscal status filter for Italian businesses
			if (this.userStore.currBusiness?.country === 'IT') {
				filtersList.push({
					title: this.getString('fiscal_status'),
					customSlot: 'fiscal-status-filters'
				});
			}

			filtersList.push({
				title: this.getString('only_my_orders'),
				switch: true,
				active: this.ordersStore.onlyMyOrders,
				callback: () => {
					this.ordersStore.onlyMyOrders = !this.ordersStore.onlyMyOrders;
					localStorage.setItem('onlyMyOrders', this.ordersStore.onlyMyOrders ? "true" : "false");
					this.ordersStore.refreshOrders();
				}
			});

			return filtersList;
		},
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		expandedSearch() {
			return this.windowWidth > 800;
		},
		noOrders() {
			return this.ordersStore.orderGroups.length === 0;
		},
		groupTotal() {
			if (this.ordersActionsStore.ordersPayment) {
				return this.ordersActionsStore.ordersPayment.reduce((acc, curr) => acc + curr.grandTotal, 0);
			}
			return 0;
		},
		paidValue() {
			if (this.ordersActionsStore.ordersPayment) {
				return this.ordersActionsStore.ordersPayment.reduce((acc, curr) => {
					return acc + curr.paymentsPartial
				}, 0);
			}
			return 0;
		},
		coverChargeName() {
			return this.ordersStore?.selectedOrderGroup?.room?.cover_charge_name || this.getString('cover_charge');
		},
		itemsSplit() {
			if (!this.ordersActionsStore.ordersPayment || this.ordersActionsStore.ordersPayment.length === 0) {
				return [];
			}
			let id = 0;
			let items = [];
			this.ordersActionsStore.ordersPayment.forEach(order => {
				if(order.cover_charge_num && order.cover_charge_value > 0) {
					let alreadyPaid = order.cover_charge_paid ? order.cover_charge_paid : 0;
					let toPay = order.cover_charge_num - alreadyPaid;
					if(toPay > 0) {
						items.push({
							id: id,
							order_item_id: "cover",
							order_id: order.order_id,
							name: this.coverChargeName,
							price: order.cover_charge_value,
							quantity: toPay,
							redeemed: false,
						});
						id++;
					}
				}
				order.items.forEach(item => {
					let priceFull = item.price + item.products.reduce((a, b) => a + (b.price * b.quantity), 0);
					if(priceFull > 0) {
						items.push({
							id: id,
							order_item_id: item.order_item_id,
							order_id: order.order_id,
							menu_item_id: item.item_id,
							name: item.name,
							price: priceFull,
							quantity: item.quantity,
							redeemed: item.redeemed,
							products: item.products
						});
						id++;
					}
				});
			});
			return items;
		},
		defaultDutchPeople() {
			if (this.ordersActionsStore.ordersPayment) {

				let coverStrategy = 0;
				let paymentStrategy = null;
				this.ordersActionsStore.ordersPayment.forEach(order => {
					if(order.cover_charge_num) {
						coverStrategy += order.cover_charge_num;
					}
					order.payments.forEach(payment => {
						if(payment.dutch_people) {
							paymentStrategy = paymentStrategy ? Math.min(payment.dutch_people, paymentStrategy) : payment.dutch_people;
						}
					});
				});
				if(paymentStrategy && paymentStrategy > 0) {
					return paymentStrategy;
				}
				if(coverStrategy > 0) {
					return coverStrategy;
				}
			}
			return 2;
		},
		isFiltering() {
			if(this.ordersStore.onlyMyOrders) { return true }
			if(this.ordersStore.fiscalFilter && this.ordersStore.fiscalFilter !== 'all') { return true }
			let orderModeFilters = [this.ordersStore.filterCounter, this.ordersStore.filterRooms, this.ordersStore.filterDelivery, this.ordersStore.filterTakeaway];
			return orderModeFilters.some(filter => !filter) && orderModeFilters.some(filter => !!filter);
		}
	},
	methods: {
		togglingFilters(isOpen) {
			if (!isOpen) {
				this.filtersActive = false;
			}
		},
		toggleSearch() {
			setTimeout(() => {
				this.showSearch = !this.showSearch;
				setTimeout(() => {
					if(this.$refs["search-input-modal"]) {
						this.$refs["search-input-modal"].focus();
					}
				}, 350);
			}, 100);
		},
		closeSearch() {
			if(this.showSearch) {
				this.showSearch = false;
			}
		},
		paymentDone(type, amountPartial, partialType, orderAssociatedId, itemsSplit, dutchPeople, discountOnTotal, discountPartial, appliedCoupons, printSingleItem, callback = null) {

			let oldOrdersPaymentIds = this.ordersActionsStore.ordersPayment.map(order => order.order_id);
			this.ordersActionsStore.paymentGroupDone(type, amountPartial, itemsSplit, dutchPeople, orderAssociatedId, discountOnTotal, discountPartial, appliedCoupons, printSingleItem, (success) => {
				this.counterStore.finishEditOrder();
				if (amountPartial === null) {
					this.paymentActive = false;
				} else {
					let newOrdersPayment = this.ordersStore.ordersUngrouped.filter(order => oldOrdersPaymentIds.includes(order.order_id) && !order.paid);
					if (newOrdersPayment.length > 0) {
						this.ordersActionsStore.ordersPayment = newOrdersPayment;
					} else {
						this.paymentActive = false;
					}
				}
				if(!success && type === 'paylater' && (oldOrdersPaymentIds?.length || 0) > 1) {
					this.showNotification('multi-order-restriction');
				}
				callback && callback(success);
			});

		},
		togglingPayment(isOpen) {
			if (!isOpen) {
				this.paymentActive = false;
				this.ordersActionsStore.ordersPayment = null;
			}
		},
		clickOrderRow(orderGroup) {
			this.ordersStore.selectedGroupId = orderGroup.groupIdentifier;
			this.ordersStore.activateMobileOrderSummary();
		},
		clickOnFilter(type) {
			let typesArr = ["filterRooms", "filterDelivery", "filterTakeaway", "filterCounter"];
			let allTrue = true;
			let allButMeAreFalse = true;
			typesArr.forEach(t => {
				if (t !== type) {
					if (!this.ordersStore[t]) {
						allTrue = false;
					} else {
						allButMeAreFalse = false;
					}
				} else {
					if (!this.ordersStore[t]) {
						allTrue = false;
						allButMeAreFalse = false;
					}
				}
			});
			if (allTrue) {
				typesArr.forEach(t => {
					if (t !== type) {
						this.ordersStore[t] = false;
					}
				});
			} else if (allButMeAreFalse) {
				typesArr.forEach(t => {
					this.ordersStore[t] = true;
				});
			} else {
				typesArr.forEach(t => {
					this.ordersStore[t] = t === type;
				});
			}
			this.ordersStore.refreshOrders();
		},
		clickOnFiscalFilter(type) {
			if (this.ordersStore.fiscalFilter === type) {
				this.ordersStore.fiscalFilter = 'all';
			} else {
				this.ordersStore.fiscalFilter = type;
			}
			this.ordersStore.refreshOrders();
		},
		pageChanged(page, pageSize) {
			this.ordersStore.page = page;
			this.ordersStore.pageSize = pageSize;
			this.ordersStore.refreshOrders();
		},
		switchedCompleted(index) {
			this.ordersStore.page = 0;
			this.ordersStore.showCompleted = index === 1;
			this.ordersStore.refreshOrders();
		},
		searchOrders(search) {
			if (search.length > 1) {
				this.ordersStore.search = search;
				this.ordersStore.page = 0;
				this.ordersStore.searchLoading = true;
				this.ordersStore.refreshOrders(() => {
					this.ordersStore.searchLoading = false;
				});
			} else {
				if (this.ordersStore.search) {
					this.ordersStore.search = null;
					this.ordersStore.page = 0;
					this.ordersStore.refreshOrders();
				}
			}
		},
		cancelSearch() {
			this.ordersStore.search = null;
			this.ordersStore.page = 0;
			if(this.$refs["search-input-modal"]) {
				this.$refs["search-input-modal"].currentValue = "";
			}
			if(this.$refs["search-input"]) {
				this.$refs["search-input"].currentValue = "";
			}
			this.ordersStore.refreshOrders();
		},
	},
	mounted() {
		this.noOrdersDelayed = this.noOrders;
	},
	beforeUnmount() {
		this.ordersStore.showCompleted = false;
		this.ordersStore.search = null;
		this.ordersStore.page = 0;
	},
	watch: {
		"ordersActionsStore.ordersPayment"(newVal, oldVal) {
			if (newVal !== oldVal) {
				if (newVal === null) {
					this.counterStore.customerNotEditable = false;
					this.counterStore.selectedCustomer = null;
					this.counterStore.noPayLater = false;
					this.counterStore.invoiceAdditionalData.purchase_order = null;
					this.counterStore.invoiceAdditionalData.payment_due_date = null;
				} else {
					this.paymentActive = true;
					if (this.ordersActionsStore.ordersPayment.length > 1) {
						this.counterStore.noPayLater = true;
					} else if (this.ordersActionsStore.ordersPayment.length === 1) {
						if (this.ordersActionsStore.ordersPayment[0].customer_person_id) {
							this.counterStore.selectedCustomer = {
								customer_id: this.ordersActionsStore.ordersPayment[0].customer_person_id,
								name: this.ordersActionsStore.ordersPayment[0].name,
								type: 'person',
							}
							this.counterStore.customerNotEditable = true;
						} else if (this.ordersActionsStore.ordersPayment[0].customer_company_id) {
							this.counterStore.selectedCustomer = {
								customer_id: this.ordersActionsStore.ordersPayment[0].customer_company_id,
								name: this.ordersActionsStore.ordersPayment[0].name,
								type: 'company',
							}
							this.counterStore.invoiceAdditionalData.purchase_order = null;
							this.counterStore.invoiceAdditionalData.payment_due_date = null;
						} else {
							this.counterStore.selectedCustomer = null;
							this.counterStore.customerNotEditable = false;
							this.counterStore.invoiceAdditionalData.purchase_order = null;
							this.counterStore.invoiceAdditionalData.payment_due_date = null;
						}
						this.counterStore.noPayLater = this.ordersActionsStore.ordersPayment[0].type === 'multi';
					}
				}
			}
		},
		noOrders(newVal, oldVal) {
			if(newVal !== oldVal) {
				if(newVal) {
					this.noOrdersDelayed = this.noOrders;
				} else {
					setTimeout(() => {
						this.noOrdersDelayed = this.noOrders;
					}, 210);
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.orders-container {
	--orders-padding: 12px;

	display: flex;
	flex-direction: row;
	height: 100%;

	.orders-list-container {
		width: calc(100% - 370px);
		overflow-y: auto;
		position: relative;
		@include hideScrollbar;

		.macro-filters-container {
			background: rgba(var(--rgb-bg-primary-1), 67%);
			box-shadow: inset -3px -3px 6px var(--color-box-shadow-2);
			border-radius: 0 0 13px 0;
			opacity: 1;
			backdrop-filter: blur(6px);
			-webkit-backdrop-filter: blur(6px);
			position: sticky;
			top: 0;
			left: 0;
			z-index: 5;
			padding: var(--orders-padding);
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			@media (max-width: 750px) {
				border-radius: 0 0 13px 13px;
			}

			.first-row {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				gap: 15px;
				height: 56px;

				:deep(.switch-container) {
					height: 48px;

					.switch-slider::before {
						height: 38px;
					}

					p {
						font-size: 12px;
					}

					@media (max-width: 460px) {
						width: 200px;
						min-width: 200px;
					}

					@media (max-width: 350px) {
						width: 180px;
						min-width: 180px;
					}

				}

				.right-filters {
					display: flex;
					flex-direction: row;
					justify-content: flex-end;
					align-items: center;
					gap: 8px;
				}

				.search-container {
					display: flex;
					flex-direction: row;
					justify-content: flex-end;
					align-items: center;

					.input-wrapper {
						width: 200px;
						border: 1px solid rgba(0,0,0,0);
						border-radius: 13px;
						transition: border 0.2s ease-in-out;

						&.searching {
							border: 1px solid var(--color-primary);
						}

						:deep(.input-element) {

							input {
								height: 48px;
								padding-left: 32px;
							}
						}

						@media (max-width: 950px) {
							width: 150px;
						}

						@media (max-width: 410px) {
							width: 120px;
						}

						@media (max-width: 350px) {
							width: 170px;
						}
					}

					.search-loader, .search-icon {
						margin-right: 10px;
					}

				}
			}

		}

		.orders-list {
			width: 100%;
			min-height: calc(100% - 88px - (var(--orders-padding) * 4));
			padding: var(--orders-padding);
			position: relative;

			.warning-old-qrs {
				padding: 8px 10px;
				background-color: rgba(35, 82, 162, 0.12);
				box-shadow: inset 0 2px 3px var(--color-box-shadow-2);
				border-radius: 13px;
				margin-bottom: var(--orders-padding);
				display: flex;
				flex-direction: row;
				align-items: center;

				.warning-icon {
					margin-right: 12px;
					width: 25px;
					height: 25px;

					:deep(svg) {
						width: 100%;
						height: 100%;

						.fill {
							fill: $primary;
						}
					}
				}

				.warning-info {
					width: calc(100% - 37px);
					display: flex;
					flex-direction: column;
					justify-content: flex-start;
					align-items: flex-start;

					.warning-title {
						font-size: 16px;
						font-weight: 700;
						color: var(--color-txt);
						margin-bottom: 4px;
					}

					.warning-body {
						font-size: 14px;
						color: var(--color-txt);
					}
				}
			}

			.all-orders-container {
				transition: opacity 0.2s ease 0.2s;
				opacity: 0;

				&.appearing {
					opacity: 1;
				}
			}

			.orders-list-wrapper {
				display: flex;
				flex-wrap: wrap;
				--num-items: 1;
				--gap-size: 12px;
				gap: var(--gap-size);
				width: 100%;

				@media (min-width: 700px) {
					--num-items: 2;
				}

				@media (min-width: 751px) {
					--num-items: 1;
				}

				@media (min-width: 1070px) {
					--gap-size: 12px;
					--num-items: 2;
				}

				@media (min-width: 1440px) {
					--num-items: 3;
				}

				@media (min-width: 2050px) {
					--gap-size: 16px;
					--num-items: 4;
				}

				.order-row {
					width: calc((100% / var(--num-items)) - ((var(--num-items) - 1) * var(--gap-size) / var(--num-items)));
				}
			}

			.no-orders-container {
				width: calc(100% - (var(--orders-padding) * 2));
				opacity: 0;
				transition: opacity 0.2s ease;
				position: absolute;
				top: var(--orders-padding);
				left: var(--orders-padding);

				&.appearing {
					opacity: 1;
				}

				.no-orders {
					width: 100%;
					background-color: var(--color-bg);
					border-radius: 13px;
					border: 2px dashed $primary;
					padding: 20px;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
					min-height: 130px;

					.no-orders-text {
						font-size: 18px;
						color: $primary;
						font-weight: 700;
					}
				}
			}

		}

		.pagination-container {
			padding: var(--orders-padding);
		}
	}

	.order-details-container {
		width: 370px;
		overflow-y: auto;
		padding: var(--orders-padding);
		@include hideScrollbar;
		position: relative;

		&:before {
			content: "";
			display: block;
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			background: black;
			opacity: 0;
			transition: opacity 0.5s ease;
		}
	}

	@media (max-width: 1080px) {
		--orders-padding: 10px;

		.orders-list-container {
			width: calc(100% - 330px);
		}

		.order-details-container {
			width: 330px;
		}
	}

	@media (max-width: 750px) {
		--orders-padding: 8px;

		.orders-list-container {
			width: 100%;
		}

		.order-details-container {
			width: 100%;
			height: 100%;
			align-items: center;
			position: absolute;
			top: 0;
			z-index: 8;
			display: none;
			justify-content: flex-end;

			.order-summary-container {
				width: 100%;
				max-width: 400px;
				margin-right: -100%;

			}

			&.transition {
				display: flex;

				&:before {
					opacity: 0;
				}
			}

			&.active {

				&:before {
					opacity: 0.67;
				}

				.order-summary-container {
					margin-right: 0;
				}
			}

		}
	}


	@media (max-height: 500px) and (max-width: 750px) {
		.order-details-container {
			min-height: 100%;
			height: unset;
		}
	}

	@media (max-width: 480px) {
		.order-details-container {
			padding-left: 44px;
		}
	}
}

.list-item-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	width: 100%;
	gap: 8px;

	.list-item-title {
		font-size: 16px;
		color: var(--color-txt);

		@media (max-width: 560px) {
			font-size: 14px;
		}
	}

	.filters-order-mode, .filters-fiscal-status {
		margin-left: auto;
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
		flex-wrap: wrap;
		gap: 10px;

		@media (max-width: 500px) {
			gap: 6px;
		}
	}
}

.order-switch {
	border-radius: 13px;
	border: 1px solid $primary;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 9px;
	transition: background-color 0.25s ease-in-out;
	cursor: pointer;
	width: 48px;
	height: 48px;

	img {
		width: 20px;
		height: 20px;
	}

	@media (max-width: 350px) {
		width: 38px;
		height: 38px;
		padding: 6px;

		img {
			width: 16px;
			height: 16px;
		}
	}

	&.order-switch-search, &.order-switch-filter {
		box-shadow: 0 1px 2px var(--color-alpha-4);
		background-color: var(--color-bg);
		border: 1px solid var(--color-bg);
		transition: border 0.25s ease-in-out, background-color 0.25s ease-in-out;
		position: relative;

		&.selected {
			background-color: var(--color-alpha-1);
			border: 1px solid var(--color-primary);
		}

		&.searching {
			border: 1px solid var(--color-primary);
			background-color: var(--color-active-button);
		}

	}

}
</style>